<template>
  <div class="panel-card-view w-full flex items-center">
    <div class="items-center justify-between w-full">
      <div v-for="(item, index) in params" :key="index">
        <!-- 区切り線 -->
        <vs-divider v-if="index !== 0" class="my-3" />
        <div class="flex justify-between items-center">
          <!-- カードタイトル -->

          <div class="title flex items-center">
            <span class="font-semibold">{{ item.title }}</span>
            <span v-show="item.option">（{{ item.option }}）</span>
          </div>

          <!-- カード値 -->
          <div :class="{ flex: item.isVarticalValues }">
            <div v-for="(value, index2) in item.values" :key="index2">
              <div class="value flex">
                <span class="mx-2">
                  {{ value.value }}
                </span>
                <div class="value__unit flex items-end">
                  {{ value.unit }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    params: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";
@import "@/assets/scss/aisea/_typography.scss";
@import "@/assets/scss/aisea/fuel-consumption.scss";

.panel-card-view {
  @extend .panel-card-outline;
  border-radius: 8px;
  padding: 12px 16px;

  .title {
    font-size: 14px;
    color: $aisea-dark-gray;
  }

  .value {
    font-size: 24px;
    color: $aisea-blue;
    font-weight: 500;

    &__small {
      font-size: 24px;
    }

    &__unit {
      font-size: 14px;
      font-weight: 400;
    }
  }
}
</style>
